<template>
  <div class="agreement-page">
    <div class="content">
      <h1>用户服务协议</h1>
      <div class="item">
        <h2>微博营销平台用户服务协议</h2>
        <p>
          <strong
            >1.请您（以下亦称“用户”）审慎阅读、充分理解本协议全部条款，并选择接受或不接受本协议，特别是免除或者限制责任的条款、法律适用和争议解决条款及其他以粗体或下划线标识的条款，您应重点阅读。您的注册、登录、使用微博营销平台等行为将视为您对本协议的完全理解，并同意接受本协议各项条款的约束，本协议将构成您与微博营销平台运营方之间直接有约束力的法律文件。</strong
          >
        </p>
        <p>
          <strong
            >2.除本协议以外，您还需遵守微博营销平台个人信息保护政策等微博营销平台已公示或将来公示的各项政策、规则、声明、提示及类似文件或信息。所有政策、规则、声明、提示及类似文件或信息均为本协议不可分割的组成部分，与本协议具有同等的法律效力。</strong
          >
        </p>
        <p>
          <strong
            >3.根据相关法律法规政策或运营需要，微博营销平台运营方会不时修改本协议，您需要不时查阅最新版协议。修改后的协议一经公布即生效并替代原协议，若您不接受修改后的协议条款，您应当立即停止使用微博营销平台；否则，您的继续使用行为将视为您接受修改后的协议条款。</strong
          >
        </p>
        <p>
          <strong
            >4.
            微博营销平台运营方可能发生变更或将本协议项下权利义务委托给其关联公司进行运营、管理及履行，微博营销平台运营方将竭力避免前述变更或委托给您的使用带来不便，并通过适当方式进行通知。</strong
          >
        </p>
      </div>
      <div class="item">
        <h2>一、定义</h2>
        <p>
          1.1
          微博营销平台：指网址为https://marketing.hd.weibo.com/&nbsp;的网络平台、客户端及其自媒体平台。
        </p>
        <p>
          1.2
          微博营销平台运营方：指微博营销平台的网络及技术服务提供者，以下也可称为“运营方”。
        </p>
        <p>
          1.3
          微博营销平台服务：指微博营销平台运营方通过微博营销平台向您提供的产品/服务。
        </p>
        <p>
          1.4关联公司：指一方控制另一方或为另一方所控制或双方共同受控制于同一实体的任何企业。控制是指直接或间接拥有该企业百分之五十（50％）以上的股权、投票权或管理权。
        </p>
      </div>
      <div class="item">
        <h2>二、服务说明</h2>
        <p>
          2.1
          微博营销平台服务内容包括但不限于营销案例、营销咨询、营销课程板块下提供的相关服务，用户可以在微博营销平台中按照运营方提供的方式查阅、下载营销案例，购买、查看营销案例课程，发布观点、评论、图片等，运营方有权不定期对微博营销平台服务进行调整，包括但不限于变更服务项目、内容、形式等。如您不接受服务调整，请您立即停止使用微博营销平台服务；否则，您的继续使用行为将被视为您对调整服务的完全同意且承诺遵守。
        </p>
        <p>
          <strong
            >2.2为优化用户体验，您在使用微博营销平台过程中可能会同时接受来自运营方及其关联公司所提供的相关服务，您对此予以认可并接受。</strong
          >
        </p>
        <p>
          2.3对于运营方所提供的收费服务，运营方会在您使用前给予明确提示，您根据提示确认并支付相关费用后，方可使用该等收费服务，否则您将无法使用相关服务。
        </p>
        <p>
          <strong
            >2.4您充分理解并接受，运营方可能通过微博营销平台关联APP、手机短信、网页或其他合法方式向您发送商品促销或其他相关商业信息，包括但不限于通知信息、宣传信息、广告信息等。</strong
          >
        </p>
        <p>
          2.5运营方仅提供与微博营销平台相关的服务，除此之外与相关网络服务有关的设备（如个人电脑、手机、及其他与接入互联网或移动网有关的装置）及所需的费用（如为接入互联网而支付的电话费及上网费、为使用移动网络而支付的手机费等）均由您自行负担。
        </p>
        <p>
          2.6为了改善用户体验、完善服务内容、保证服务的安全性、功能的一致性，运营方将不断努力开发新的服务，并为用户不时提供软件更新（这些更新可能会采取软件替换、修改、功能强化、功能改变、版本升级等形式）。
        </p>
        <p>
          2.7
          微博营销平台软件新版本发布后，运营方不保证旧版本软件的继续可用及或提供相应的客户服务，请您随时核对并下载最新版本。
        </p>
      </div>
      <div class="item">
        <h2>三、虚拟货币</h2>
        <p>
          3.1运营方将在微博营销平台发行虚拟货币——金币（名称的变化不影响本条的适用）。金币可用于购买微博营销平台的营销课程，该等社会化营销课程的价格均以金币为单位，具体价格信息将由运营方自行决定并在相关服务页面上显示。
        </p>
        <p>
          3.2您默认已开通金币账户，可进行金币购买和消费。您可在“我的”-“我的账户”页面查询到您的金币余额。
        </p>
        <p><strong>3.3 您理解并确认：</strong></p>
        <p>
          <strong
            >3.3.1金币一经充值成功，除法律法规明确规定外，在任何情况下不能兑换为法定货币，不能转让他人；金币账户充值完成后，不予退款；</strong
          >
        </p>
        <p>
          <strong
            >3.3.2除非法律法规明确规定或本协议另有约定，您已购买的任何收费服务不能以任何理由退购或调换成其他服务。</strong
          >
        </p>
        <p>
          <strong
            >3.3.3金币只能用于购买微博营销平台上的各类增值服务，任何情况下不得与运营方以外的第三方进行金币交易，亦不得在除微博营销平台以外的第三方平台（如淘宝）上进行交易；如违反前述约定，造成您或第三方的任何损失，由您自行解决，与运营方无关，且如运营方有理由怀疑您的金币账户或使用情况有作弊或异常状况，运营方将拒绝您使用金币进行支付，直至按本协议约定采取相关封禁等措施。</strong
          >
        </p>
        <p>
          <strong
            >3.4您使用微博营销平台所获得的积分应遵循微博营销平台的积分规则，仅用于下载及查看案例，在任何情况下不能兑换为金币或法定货币，不能转让他人，对其不享有所有权。运营方许可您按照平台规则进行使用，运营方对上述积分不承担任何赔偿责任。</strong
          >
        </p>
      </div>
      <div class="item">
        <h2>四、使用规范</h2>
        <p>
          4.1您应具有履行本协议所必须具备的民事权利能力及民事行为能力，有资格从事本协议项下的合作，并有资格或已获得充分授权签署本协议，不会违反您与任何第三方之间的协议或约定。
        </p>
        <p>
          4.2您可通过微博营销平台上提供的注册方式进行账号注册，并自行编辑注册信息中的账号名称、昵称、头像、简介等（以下简称“账号信息”），您的微博营销平台账号信息应当遵守以下规则：
        </p>
        <p>4.2.1遵守相关法律法规，不得含有违法、侵权和不良信息；</p>
        <p>
          <strong
            >4.2.2应当使用真实身份信息及个人资料，不得以虚假或冒用的居民身份信息、企业相关信息进行注册；未经相关权利人授权，您不得以他人或其他组织机构名义注册微博营销平台账号，亦不得使用引人误解的信息注册微博营销平台账号，包括但不限于让人误认为该账号与其他个人或机构组织存在关联关系的名称、头像或简介等；</strong
          >
        </p>
        <p>
          <strong
            >4.2.3您需对您所提供的所有资料及信息（包括但不限于微博营销平台账号信息等）的合法性、真实性、有效性及准确性予以保证，如果您的资料及信息有变更的，您应提前通知运营方，并在运营方要求的时限内提供新的资料及信息。因您资料或信息发生变更但没有及时告知运营方，由此而导致的所有损失将由您自行承担；您同时也理解，运营方需要合理的时间对您的资料或信息进行变更，在运营方明确告知您信息变更成功之前，运营方不对可能产生的损失负责；</strong
          >
        </p>
        <p>
          <strong
            >4.3您微博营销平台账号的所有权归运营方所有，您完成申请注册流程后，获得相应账号的使用权。您的微博营销平台账号仅限于您本人使用，您应当妥善保管微博营销平台账号及密码，并对任何利用您账号及密码所进行的活动承担完全的责任；未经运营方许可，不得以任何形式许可他人使用您的微博营销平台账号，或擅自买卖、转让、出租任何微博营销平台账号或微博营销平台账号昵称。</strong
          >
        </p>
        <p>
          <strong
            >4.4当您的账号或密码遭到未获授权的使用或者发生其他任何安全问题时，您应当立即有效通知运营方；同时您理解运营方对您的任何请求采取行动需要合理时间，且运营方应您请求而采取的行动可能无法避免或阻止侵害后果的形成或扩大；您亦理解，在账号和密码匹配时，运营方无法对非法或未经您授权使用您账号及密码的行为做出甄别，因此，对任何使用您账号和密码登录并使用微博营销平台的行为，运营方均有权认为是您本人的行为，所导致的责任仍由您自行承担。</strong
          >
        </p>
        <p>
          <strong
            >4.5账号因您保管不当、遭他人攻击、诈骗等非运营方故意或重大过失导致的损失及后果，您应当通过司法、行政等救济途径向侵权行为人追偿。运营方根据自己的判定，在怀疑账号被不当使用时，有权自行拒绝或限制账号的使用，或注销该账号，同时终止本协议。</strong
          >
        </p>
        <p>
          4.6未经权利人依法授权，您不得以任何形式将微博营销平台用户所发布的内容进行商业化使用。
        </p>
        <p>
          <strong
            >4.7如您在申请开通微博营销平台账号后在任何连续365日内未登录账号，则运营方有权回收用户账号。您的账号如被回收，您将不能再使用该账号登录微博营销平台平台，相应服务同时终止。</strong
          >
        </p>
        <p>
          4.8对于您在微博营销平台中发布或存储的内容，建议您自行不定期备份。如您通过使用注销账号功能而主动停止使用微博营销平台账号或者因长期未登录微博营销平台账号致使被运营方回收的，运营方无法向您返还或提供任何数据。
        </p>
        <p>
          4.9您需要对您的微博营销平台账号下的一切行为独立负责，承担您账号下一切行为可能会导致的各种后果。您应当保证您对通过微博营销平台制作、复制、上传、发布、传播的任何内容享有合法权益，若因该等内容发生违法违规或侵犯了任何第三方的合法权益，需由您承担全部法律责任。请您不要利用微博营销平台制作、复制、上传、发布、传播如下内容：
        </p>
        <p>4.9.1违反宪法、法律法规或政策规定；</p>
        <p>
          4.9.2颠覆国家政权，推翻社会主义制度，煽动、分裂国家，破坏国家统一；
        </p>
        <p>4.9.3泄露国家秘密、危害国家安全或者损害国家荣誉和利益；</p>
        <p>4.9.4煽动民族仇恨、民族歧视，破坏民族团结；</p>
        <p>4.9.5危害社会公德，损害民族优秀文化传统；</p>
        <p>4.9.6捏造或者歪曲事实，散布谣言，扰乱社会秩序，破坏社会稳定；</p>
        <p>4.9.7涉及性别、政治、宗教、民族、地域歧视、色情、暴力等话题；</p>
        <p>
          4.9.8侵犯运营方、其他用户或第三方合法权益的，包括但不限于侵害他人知识产权、商业秘密，侮辱或者捏造事实诽谤他人，恶意攻击，侵害公民个人隐私等；
        </p>
        <p>
          <strong
            >4.9.9干扰微博营销平台正常运营、其他用户或其他第三方正常使用微博营销平台及相关产品或服务的，包括但不限于骚扰、垃圾广告、含有任何性或性暗示以及任何其他低俗类信息；</strong
          >
        </p>
        <p>4.9.10其他运营方有理由认为不适当的。</p>
        <p>
          <strong
            >4.10您知悉、理解并同意，运营方可能会对您的相关操作及发布的内容进行审核，包括但不限于设置过滤关键词、人工审核或抽查等；若您相关操作或所发表的内容无法通过前述审核，将会被屏蔽、删除、或出现操作不成功等情形。运营方上述审核及监控行为并不意味着运营方对于您操作行为的合法合规性、不侵权承担任何保证、担保、连带责任或减免您的相关保证义务，您仍需要对您的操作行为及所发布的内容独立负责。</strong
          >
        </p>
        <p>
          4.11未经运营方事先书面许可，您不会将本协议项下的全部或部分权利义务、责任转让给任何第三方。
        </p>
      </div>
      <div class="item">
        <h2>五、知识产权</h2>
        <p>
          5.1微博营销平台及相关产品和服务的一切著作权、商标权、专利权、商业秘密等知识产权，以及相关的所有信息内容（包括但不限于文字、图片、界面设计、版面框架等）均受中华人民共和国相关法律法规及相关国际条约的保护，由运营方及其关联公司合法享有，依法应由其他权利人享有的除外。
        </p>
        <p>
          5.2
          未经运营方或相关权利人事先书面授权，您不得使用、复制、修改、出售、传播部分或全部上述运营方或相关权利人拥有知识产权的内容，或加以制作衍生服务或软件，或通过进行还原工程、反向组译及其他方式破译源代码等。
        </p>
        <p>
          <strong
            >5.3您同意不可撤销地免费授权运营方及其关联公司可以商业或非商业之目的在微博营销平台及其关联产品和服务上使用您在微博营销平台中提交或发表的内容（包括但不限于留言、评论、笔记等），以及将前述内容许可给第三方使用。您对运营方及其关联公司的前述授权并不改变您发布内容的所有权及知识产权归属，也并不影响您行使您对所发布内容的合法权利。</strong
          >
        </p>
        <p>
          <strong
            >5.4为提高服务使用感受和满意度，您同意运营方可以自行或许可第三方对用户数据进行调查研究和分析，从而进一步优化微博营销平台及相关服务。</strong
          >
        </p>
      </div>
      <div class="item">
        <h2>六、免责声明</h2>
        <p>
          <strong
            >6.1您使用微博营销平台及相关服务的实际效果，将受到多种因素的影响，包括但不限于市场行情、用户喜好、营销策略、您的产品或服务质量等，运营方不会对您使用微博营销平台及相关服务的效果做任何明示或暗示的担保，您应当自行承担使用微博营销平台及相关服务所产生的责任及后果。</strong
          >
        </p>
        <p>
          <strong
            >6.2您上传至网络的文字（如个人信息等）、图片、视频等内容可能会被第三方复制、修改、转载或做非法用途，您应充分意识此类风险的存在。运营方将尽力提供安全的信息服务环境，但是无法保证上述风险完全排除，您明确同意使用微博营销平台及相关服务所存在的风险（包括但不限于受到第三方侵权或对第三方造成侵权）完全由您自行承担，运营方对此不承担任何责任。</strong
          >
        </p>
        <p>
          <strong
            >6.3为保障您的合法权益，您应确保您所提供的联系方式（包括但不限于邮箱地址、手机号码等）真实有效，并不时登录微博营销平台查阅最新信息，如因非运营方原因造成您无法如约获取相关信息（该类信息可能会对您的权利义务产生重大的有利或不利影响），由此造成的损失由您自行承担，运营方对此不承担任何责任。</strong
          >
        </p>
        <p>
          <strong
            >6.4运营方可能会基于服务风险、运营管理需求，或其他善意原因及事由（包括但不限于产品或服务优化、升级、停机维护、设备检修、恶意网络攻击等）中断及中止部分或全部服务、限制部分或全部功能、或提供新功能等，此种情况下运营方将尽量提前在微博营销平台相关页面中进行公示，运营方的公示行为视为有效通知，运营方对此不承担任何责任。</strong
          >
        </p>
        <p>
          <strong
            >6.5为方便您使用，运营方可能会提供第三方网站或资源链接。您应了解，除非另有声明，运营方无法对第三方服务进行控制。您因下载、传播、使用或依赖上述网站或资源所生的损失，由您自行承担责任。</strong
          >
        </p>
        <p>
          <strong
            >6.6您应从微博营销平台官网或其他拥有运营方授权的第三方获得安装程序。如果您从未经运营方授权的第三方获取微博营销平台安装程序或名称相同的安装程序，运营方无法保证该软件能够正常使用，并对因此给您造成的损失不承担任何责任。</strong
          >
        </p>
        <p>
          <strong
            >6.7您通过微博营销平台发布的任何信息，及通过微博营销平台传递的任何观点不代表运营方之立场，运营方亦不对其完整性、真实性、准确性负责。您对于可能会在微博营销平台上接触到的非法的、错误的或存在其他失宜之处的信息，及被错误归类或是带有欺骗性的发布内容，应自行做出判断。在任何情况下，因前述非正当信息而导致的任何损失或伤害，应由您与相关行为主体直接独立解决，与运营方无关。</strong
          >
        </p>
      </div>
      <div class="item">
        <h2>七、不可抗力</h2>
        <p>
          7.1不可抗力，是指本协议双方不能预见、不能合理控制或即使预见也无法避免的事件，该事件妨碍、影响或延误任何一方根据本协议履行其全部或部分义务。鉴于网络的特殊属性，除自然灾难、战争、政府行为（政策、法律法规、监管部门要求等）以外，还包括：
        </p>
        <p>7.1.1黑客攻击、计算机病毒侵入或发作；</p>
        <p>
          7.1.2计算机系统遭到破坏、瘫痪或无法正常使用而导致信息或纪录的丢失；
        </p>
        <p>7.1.3电信部门技术调整导致之重大影响；</p>
        <p>7.1.4因政府管制而造成的暂时性关闭；</p>
        <p>
          7.1.5宽带或其他网络设备或技术提供商的服务延迟、故障或其他类似事件等。
        </p>
        <p>
          7.2由于上述不可抗力事件致使本协议部分或全部不履行或迟延履行的，双方彼此不承担任何违约责任。但遭遇不可抗力事件的一方，应于不可抗力事件发生后15个工作日内书面通知对方，并提供相关证明。双方可按照事件对协议履行的影响程度，再行决定是否继续履行本协议或终止本协议。
        </p>
      </div>
      <div class="item">
        <h2>八、违约责任</h2>
        <p>
          8.1如因运营方违反有关法律、法规或本协议相关约定而给您造成损失的，相应的直接损失赔偿责任由运营方承担。
        </p>
        <p>
          8.2您同意保障和维护微博营销平台及其他用户的合法权益，如因您违反有关法律、法规或本协议之约定而给运营方或任何其他第三方造成损失的，您同意承担全部损害赔偿责任。运营方或其关联公司遭受的损失包括但不限于由此引起的处罚、诉讼、索赔、纠纷及支出的赔偿/和解金额、合理律师费用、调查取证费用等。
        </p>
        <p>
          <strong
            >8.3如运营方发现您存在违反本协议相关约定的行为或收到关于您涉嫌违反本协议相关约定的举报或投诉的，运营方或其授权主体有权依据其合理判断不经通知立即采取一切必要措施以减轻或消除您行为造成的影响，该等“一切必要措施”包括但不限于以下一项或多项：</strong
          >
        </p>
        <p>
          <strong
            >8.3.1更改、屏蔽或删除相关内容，包括但不限于用户资料、发布内容、链接等；</strong
          >
        </p>
        <p>
          <strong
            >8.3.2变更、限制或暂停微博营销平台账号部分或全部功能，包括但不限于警告违规账号、账号封禁、账号禁言；</strong
          >
        </p>
        <p>
          <strong
            >8.3.3冻结直至扣除账户资金，用于弥补给运营方及其关联公司、他人造成的损失；</strong
          >
        </p>
        <p><strong>8.3.4注销用户账号；</strong></p>
        <p><strong>8.3.5单方暂停或终止本协议；</strong></p>
        <p>
          <strong
            >8.3.6其他运营方认为合理的措施，包括但不限于向有关监管部门举报、起诉等。</strong
          >
        </p>
      </div>
      <div class="item">
        <h2>九、联系运营方</h2>
        <p>
          当您对本协议有任何意见或建议或与运营方产生任何争议纠纷时，您可通过微博营销平台的客服功能或拨打4000-970-970联系运营方。
        </p>
      </div>
      <div class="item">
        <h2>十、法律适用及争议解决</h2>
        <p>
          <strong
            >10.1本协议的订立、效力、解释、适用及争议解决等一切事宜，均适用中华人民共和国法律。</strong
          >
        </p>
        <p>
          <strong
            >10.2因本协议存在任何争议的，双方应当友好协商解决；协商不成的，任何一方均可向北京市海淀区人民法院提起诉讼。</strong
          >
        </p>
      </div>
      <div class="item">
        <h2>十一、其他</h2>
        <p>
          11.1本协议的所有条款标题仅为阅读方便，并不具有实际含义，不能作为本协议条款解释的依据。
        </p>
        <p>
          11.2本协议的任何一方未能及时行使本协议项下的权利不应被视为放弃该权利，也并不影响该方在未来行使该权利。
        </p>
        <p>
          11.3本协议任何部分被视为无效或不可执行的，不影响本协议其他条款或部分的有效性和可执行性，其他条款对双方仍具有约束力。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.agreement-page {
  padding: 150px 0 88px;
  .content {
    width: 984px;
    margin: 0 auto;
  }
  .item {
    margin-bottom: 24px;
  }
  h1 {
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    line-height: normal;
    margin-bottom: 32px;
  }
  h2,
  .title {
    margin-bottom: 16px;
    font-weight: bold;
    font-size: 16px;
  }
  p {
    margin-bottom: 12px;
    text-align: justify;
    font-size: 14px;
  }
  strong {
    font-weight: bold;
  }
}
</style>
